import styled from '@emotion/styled';
import {SustainabilityHotelBadge as SustainabilityHotelBadgeUI} from '@travel-frontend/ui-components';

export const SustainabilityHotelBadge = styled(SustainabilityHotelBadgeUI)`
  display: inline-flex;
  flex-direction: row;
  margin-left: 4px;
  margin-bottom: -4px;
  align-self: baseline;
`;
